<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>

        <v-toolbar flat>
          <h2>Пользователи</h2>

          <v-spacer></v-spacer>

          <v-text-field
          label="поиск по фильтру"
          v-model="search"
          append-icon="search"
          style="max-width: 400px"
          outlined clearable hide-details flat
          ></v-text-field>
          <v-dialog
            v-model="addUserDialog"
            :overlay="false" persistent
            max-width="600px"
            transition="dialog-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon class="mx-3" color="secondary" v-on="on" :disabled="!ishyperadmin">
                <v-icon>
                  add
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title primary-title>
                Добавление пользователя
                <v-spacer></v-spacer>
                <v-btn icon color="secondary" @click="user={};addUserDialog=false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="isAddFormValid">
                  <v-text-field
                    v-model="user.email"
                    :rules="emailRules"
                    label="email"
                    required
                  ></v-text-field>
                  <v-select
                    :items="userScopes"
                    v-model="user.scopes"
                    multiple
                    label="Права доступа"
                    required
                  ></v-select>
                  <v-select
                    :items="orgs"
                    item-text="orgid"
                    item-value="orgid"
                    v-model="user.orgid"
                    label="Организация"
                    required
                  ></v-select>
                  <v-select
                    :items="userCanAddPayments"
                    v-model="user.canaddpaymentsas"
                    label="Может проводить платежи через"
                    multiple
                    required
                  ></v-select>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="orange" outlined text @click="user={};addUserDialog=false">Отмена</v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="!isAddFormValid || !user.orgid" color="primary" outlined text @click="addUser()">Добавить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog
            v-model="editUserDialog"
            persistent :overlay="false"
            max-width="500px"
            transition="dialog-transition"
          >
            <v-card>
              <v-card-title primary-title>
                Редактирование пользователя
                <v-spacer></v-spacer>
                <v-btn icon color="secondary" @click="user={};editUserDialog=false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form v-model="isEditFormValid">
                  <v-text-field
                    v-model="user.email"
                    :rules="emailRules"
                    label="email"
                    required
                  ></v-text-field>
                  <v-select
                    :items="userScopes"
                    v-model="user.scopes"
                    multiple
                    label="Права доступа"
                    required
                  ></v-select>
                  <v-select
                    :items="orgs"
                    item-text="orgid"
                    item-value="orgid"
                    v-model="user.orgid"
                    label="Организация"
                    required
                  ></v-select>
                  <v-select
                    :items="userCanAddPayments"
                    v-model="user.canaddpaymentsas"
                    label="Может проводить платежи через"
                    multiple
                    required
                  ></v-select>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="orange" outlined text @click="user={};editUserDialog=false">Отмена</v-btn>
                <v-spacer></v-spacer>
                <v-btn :disabled="!isEditFormValid || !user.orgid" color="primary" outlined text @click="updateUser()">Сохранить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </v-flex>
      <v-flex>
        <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
          :headers="headers"
          :items="users"
          :items-per-page="-1"
          :search="search"
          item-key="operatorid"
          sort-by="operatorid"
          hide-default-footer
          dense
        >
        <template v-slot:item.scopes="{ item }">
          <v-tooltip left max-width="640">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" style="min-height: 26px !important">
                <v-list-item-subtitle class="caption pa-0" style="max-width: 60ch !important">
                  <span>Права</span>
                </v-list-item-subtitle>
              </v-list-item>
            </template>
            <span>
              <b>Права:</b><br/>
              <span v-for="scope in item.scopes" :key="scope">{{ scope }}<br /></span>
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.canaddpaymentsas="{ item }">
          <span v-for="capas in item.canaddpaymentsas" :key="capas">{{ capas }}, </span>
        </template>
        <template v-slot:item.blocked="{ item }">
          <v-icon small color="green" v-if="item.blocked === true">check</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="">
            <v-btn v-if="!item.blocked" class="px-2" color="warning" small text @click="blockUser(item)">
              block
              <v-icon small>block</v-icon>
            </v-btn>
            <v-btn v-else class="px-2" color="green" small text @click="unblockUser(item)">
              unblock
              <v-icon small>block</v-icon>
            </v-btn>
            <v-btn class="px-2" color="info" small text @click="user = item; editUserDialog = true">
              edit
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn class="px-2" color="error" x-small text @click="deleteUser(item)">
              delete
              <v-icon small>delete</v-icon>
            </v-btn>
          </div>
        </template>
        </v-data-table>
      </v-flex>
      <Confirmation></Confirmation>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import Confirmation from '@/components/Confirmation'

export default {
  name: 'Users',
  data: () => ({
    users: [],
    user: {},
    orgs: [],
    search: '',
    addUserDialog: false,
    isAddFormValid: false,
    isEditFormValid: false,
    editUserDialog: false,
    userScopes: [
      'cafeadmin',
      'backoffice',
      'operator',
      'editor',
      'admin',
      'bookkeeper',
      'hyperadmin'
    ],
    userCanAddPayments: [
      'cds', 'cdsobl'
    ],
    emailRules: [
        v => !!v || 'Поле e-mail не может быть пустым',
        v => /\S+@\S+\.\S+/.test(v) || 'E-mail должен быть корретный'
      ],
  }),
  components: { Confirmation },
  methods: {
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    },
    async fetch () {
      try {
        const { users } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-users',
          pl: {}
        })
        this.users = users
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async fetchOrgs () {
      const { orgs } = await this.$store.dispatch('sioRequest', {
        topic: 'fetch-orgs-all',
        pl: {}
      })
      this.orgs = orgs
    },
    async addUser () {
      try {
        this.user.invitedby = this.profile.email
        const user = await this.$store.dispatch('sioRequest', {
          topic: 'add-user',
          pl: this.user
        })
        this.user = {}
        this.addUserDialog = false
        await this.fetch()
      } catch (err) {
        this.$store.dispatch(err)
      }
    },
    async updateUser (item) {
      try {
        const newOne = await this.$store.dispatch('sioRequest', {
          topic: 'update-user',
          pl: this.user
        })
        this.user = {}
        this.editUserDialog = false
        await this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async blockUser (item) {
      try {
        await this.$store.dispatch('confirm', `Заблокировать пользователя ${item.email} ?`)
        await this.$store.dispatch('sioRequest', {
          topic: 'block-user',
          pl: {
            operatorid: item.operatorid
          }
        })
        await this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async unblockUser (item) {
      try {
        await this.$store.dispatch('confirm', `Разблокировать пользователя ${item.email} ?`)
        await this.$store.dispatch('sioRequest', {
          topic: 'unblock-user',
          pl: {
            operatorid: item.operatorid
          }
        })
        await this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    },
    async deleteUser (item) {
      try {
        await this.$store.dispatch('confirm', `Удалить пользователя ${item.email} ?`)
        await this.$store.dispatch('sioRequest', {
          topic: 'delete-user',
          pl: {
            operatorid: item.operatorid
          }
        })
        await this.fetch()
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    ishyperadmin () {
      return this.scopes.includes('hyperadmin')
    },
    headers () {
      if (this.ishyperadmin) {
        return [
          { text: 'id', value: 'operatorid', width: 80, align: 'left' },
          { text: 'email', value: 'email', width: 200, align: 'left' },
          { text: 'Права', value: 'scopes', width: 200 },
          { text: 'Организация', value: 'orgid' },
          { text: 'Кем приглашен', value: 'invitedby' },
          { text: 'Платежи', value: 'canaddpaymentsas' },
          { text: 'Дата добавления', value: 'cts' },
          { text: 'Заблокирован?', value: 'blocked' },
          { text: 'Действия', value: 'action' }
        ]
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    async addUserDialog (val) {
      if (val) {
        await this.fetchOrgs()
      }
    },
    async editUserDialog (val) {
      if (val) {
        await this.fetchOrgs()
      }
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
